import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class UserDisciplineModel extends ModelBase<UserDisciplineModel, UserDisciplineDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = null;
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string | null = UserDisciplineModel.DEFAULT_ID;

    @observable
    public displayName: string = UserDisciplineModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = UserDisciplineModel.DEFAULT_ID;
        this.displayName = UserDisciplineModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: UserDisciplineDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: UserDisciplineDTO[]): UserDisciplineModel[] {
        const types: UserDisciplineModel[] = [];

        for (const dto of dtos) {
            const model = new UserDisciplineModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface UserDisciplineDTO {
    id: string | null;
    displayName: string;
}
